"use client";

import dynamic from "next/dynamic";

import type { GlobeProps, LanguageAudioSample } from "./Globe";

const Globe = dynamic(() => import("./Globe").then(mod => mod.Globe));

export default Globe;
export type { GlobeProps, LanguageAudioSample };
